// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-detail-confirmation .bx--checkbox-label-text{font-size:14px!important}", ""]);
// Exports
module.exports = exports;
